import React from 'react';
import Grid from '@mui/material/Grid';
import { isEmpty } from 'lodash';

import SearchToolbar from 'common-components/search-toolbar';

import SearchForm from './search-form';
import SearchResults from './search-results';
import { SearchProvider, useSearch } from './search.ctx';

const Search = () => {
  const { listData, selected, isPublishSearch, publishState } = useSearch();

  return (
    <Grid container spacing={5}>
      <Grid item xs={12}>
        <SearchForm/>
      </Grid>
      <Grid item xs={12} className={'hidePrint'}>
        <SearchToolbar
          instruments={listData}
          selected={selected}
          enablePublishUnpublish={isPublishSearch}
          isPublish={publishState === 'Published'}
          getShareIds={() => isEmpty(selected) ? listData.map(e => e.id) : selected}
        />
      </Grid>
      <Grid item xs={12}>
        <SearchResults/>
      </Grid>
    </Grid>
  );
};

export default () => (
  <SearchProvider>
    <Search/>
  </SearchProvider>
);
